<template>
  <div>
    <CBox display="flex"
flexDirection="column">
      <OmtRow v-if="doctorName"
:mb="['9px']">
        <CFlex alignItems="center">
          <CBox mr="2"
            ><OmtIcons
              size="xl"
              name="user-doctor"
              p="2"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
          /></CBox>
          <CBox width="90%"
mr="auto">
            <OmtTypography as="h1-semi-bold"
color="var(--colors-light-primary-navy-blue)" doctorName
}}< OmtTypography
          /></CBox>
        </CFlex>
      </OmtRow>
      <OmtRow v-if="doctorName"
mb="12px">
        <omt-divider />
      </OmtRow>
      <OmtRow mb="24px">
        <CBox>
          <OmtTypography as="h1-semi-bold"
color="#4A5E77">Planos atendidos</OmtTypography>
        </CBox>
      </OmtRow>
      <OmtRow v-for="(p, i) in plans"
:key="'plan-' + i" :mb="['16px']">
        <CBox border="0.5px solid var(--colors-light-secondary-divider)"
p="16px" borderRadius="8px">
          <CFlex width="100%"
            ><OmtIcons name="address-card"
mr="8px" size="lg" />
            <OmtTypography as="h2-regular"
color="#4A5E77"
              ><strong>Plano {{ p.CodigoPlano }}</strong>
            </OmtTypography></CFlex
          >
          <omt-divider />
          <CFlex width="100%"
mb="16px"
            ><OmtTypography as="h2-regular"
color="#4A5E77"
              ><strong>Contratação:</strong> {{ p.DescricaoContratacao }}</OmtTypography
            ></CFlex
          >
          <CFlex width="100%"
mb="16px"
            ><OmtTypography as="h2-regular"
color="#4A5E77"
              ><strong>Nome:</strong> {{ p.DescricaoDivulgacao }}</OmtTypography
            ></CFlex
          >
          <CFlex width="100%"
mb="16px"
            ><OmtTypography as="h2-regular"
color="#4A5E77"
              ><strong>Número de registro:</strong> {{ p.NumeroRegistro }}</OmtTypography
            ></CFlex
          >
          <CFlex width="100%"
mb="16px"
            ><OmtTypography as="h2-regular"
color="#4A5E77"
              ><strong>Segmentação:</strong> {{ p.DescricaoSegmentacao }}</OmtTypography
            ></CFlex
          >
          <CFlex width="100%"
            ><OmtTypography as="h2-regular"
color="#4A5E77">
              <strong>Situação ANS:</strong> {{ p.DescricaoAnsSituacao }}</OmtTypography
            >
          </CFlex>
        </CBox>
      </OmtRow>
    </CBox>
  </div>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import { mapState, mapActions } from "vuex";

export default {
  name: "PlansServed",
  components: {
    Footer
  },
  data() {
    return {
      plans: [],
      doctorName: ""
    };
  },
  async mounted() {
    if (!this.selectedProvider) {
      this.$router.replace({ name: "network.accredited.list" });
      return;
    }

    try {
      this.$root.$emit("show-loading");
      this.doctorName = this.selectedProvider.DescricaoPrestador;
      this.plans = await this.fetchPlanosAtendidos({
        codigoPrestador: this.selectedProvider.CodigoPrestador
      });
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("openNetworkSearch", ["selectedProvider", "rede"])
  },
  methods: {
    ...mapActions("openNetworkSearch", ["fetchPlanosAtendidos"])
  }
};
</script>
